import React from "react"
import PropTypes from "prop-types"

import SendConnectRequest from '../connect_sections/SendConnectRequest';
import AlertModal from '../app_components/AlertModal';

class SendConnectButton extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      paid: false,
      openChatCreditSection: false,
      requestSent: false,
      needsPictureModalOpen: false,
      needsIdVerifModalOpen: false
    }

    this.attemptOpenChatCredits = this.attemptOpenChatCredits.bind(this)
    this.toggleChatCredits = this.toggleChatCredits.bind(this)
    this.requestSent = this.requestSent.bind(this)
    this.closeAllModals = this.closeAllModals.bind(this)
  }

  toggleChatCredits() {
    this.setState({
      openChatCreditSection: !this.state.openChatCreditSection
    })
  }

  closeAllModals() {
    this.setState({
      needsPictureModalOpen: false,
      needsIdVerifModalOpen: false
    })
  }

  attemptOpenChatCredits() {
    if(this.props.needsToBeVerified) {
      this.setState({
        needsIdVerifModalOpen: true
      })
      return
    } else if (this.props.needsPicture) {
      this.setState({
        needsPictureModalOpen: true
      })
      return
    }
    this.toggleChatCredits()
  }

  requestSent() {
    this.setState({
      requestSent: true
    })
  }

  requestSentSection() {
    return(
      <h4>Connect Request Sent!</h4>
    )
  }

  render() {
      return (
        <div>
          {(!this.state.requestSent) && <button onClick={this.attemptOpenChatCredits} className="button_primary"><img src={this.props.chatImage} style={{height: 17, marginRight: 10, marginBottom: -2}}/> Connect with {this.props.profileUserName}</button>}
          {this.state.needsIdVerifModalOpen &&
            <AlertModal
              onClose={this.closeAllModals}
              bannerText={"This member only wants verified Connects"}
              subHeaderText="Verify your identity to Connect."
              mainText={"This member has verified their identity, and they only want to Connect with other members who have also verified their identity."}
              onClick={() => window.location.replace('/pricing?one_time=true')}
              buttonText={'Verify Identity'}
            />
          }
          {this.state.needsPictureModalOpen &&
            <AlertModal
              onClose={this.closeAllModals}
              bannerText={"Opps! Where is your picture?"}
              subHeaderText="You need to upload a picture of your face."
              mainText={"In order to contact other members, you need to complete your profile. Upload a picture first, and then you can start Connecting!"}
              onClick={() => window.location.replace('/edit')}
              buttonText={'Upload Picture'}
            />
          }
          {(this.state.openChatCreditSection) &&
            <SendConnectRequest
              requestee_id={this.props.profileUserId}
              requestee_name={this.props.profileUserName}
              closeRequest={this.toggleChatCredits}
              openRequest={this.openRequest}
              requestSent={this.requestSent}
              lexicoins={this.props.lexicoins}
              og_connection={this.props.og_connection}
              pro={this.props.pro}
              />}
          {(this.state.requestSent) && this.requestSentSection()}
        </div>
      )
  }
}

export default SendConnectButton;
